export const themeHackerTyper = {
  primaryColor: 'red',
  secondaryColor: '#f7f1f185',
  tertiaryColor: 'black',
  quarterlyColor: 'green',
  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
}
